import React from 'react';
import { COMPANY, KTT_EMAIL } from '../utils/keyGenerator';

export default function TransactionSlip({ slip }) {
  const now = new Date().toLocaleString("en-GB", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", second: "2-digit"
  });

  const rows = [
    ["Method", slip.method],
    ["Transaction Reference", slip.txnRef],
    ["Value Date", slip.valueDate],
    ["Beneficiary", slip.beneficiary],
    ["Account No.", slip.accountNo],
    ["Receiver Bank", slip.receiverBank || slip.bankName || "-"],
    ["Currency", slip.currency || "USD"],
  ];

  // Key Test — always show if available
  if (slip.keyTest) rows.push(["Key Test No.", slip.keyTest]);

  // KTT-specific
  if (slip.kttEmail) rows.push(["KTT Email", slip.kttEmail]);
  if (slip.kttCode) rows.push(["Sender KTT Code", slip.kttCode]);
  if (slip.receiverKTTCode) rows.push(["Receiver KTT Code", slip.receiverKTTCode]);
  if (slip.receiverBIC) rows.push(["Receiver BIC/SWIFT", slip.receiverBIC]);

  // API-specific
  if (slip.apiEndpoint) rows.push(["API Endpoint", slip.apiEndpoint]);

  rows.push(["Narrative", slip.narrative || "-"]);

  return (
    <div className="slip">
      <div className="slip-header">
        <div className="slip-co">{COMPANY}</div>
        <div className="slip-sub">Transaction Confirmation Slip</div>
        <div className="slip-sub">{now}</div>
      </div>

      {rows.map(([k, v]) => (
        <div key={k} className="slip-row">
          <span className="label">{k}</span>
          <span className="value">{v || "-"}</span>
        </div>
      ))}

      <div className="slip-row slip-total">
        <span>AMOUNT</span>
        <span>{slip.currency || "USD"} {parseFloat(slip.amount || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
      </div>

      {slip.keyTest && (
        <div style={{
          textAlign: "center", margin: "16px 0 0",
          padding: "10px", background: "#f8f6f0",
          borderRadius: 6, border: "1px solid #e8e0d0"
        }}>
          <div style={{ fontSize: 10, color: "#888", letterSpacing: "0.15em", fontWeight: 600 }}>SECURITY KEY TEST</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: "#B8860B", letterSpacing: "0.3em", marginTop: 4, fontFamily: "'IBM Plex Mono', monospace" }}>
            {slip.keyTest}
          </div>
        </div>
      )}

      <div className="slip-footer">
        This is a system-generated confirmation slip. No signature required.<br />
        {COMPANY} &mdash; {KTT_EMAIL}
      </div>
    </div>
  );
}
